module.exports = __webpack_public_path__ + "img/f107a31.png";